var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgComment = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 40 40",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  width: 40,
  height: 40,
  rx: 20,
  fill: "#C79A00",
  fillOpacity: 0.2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "m27.444 11.764c0.5924 0.6207 0.8889 1.3731 0.8889 2.2557v8.8445c0 0.8839-0.2965 1.6356-0.8889 2.2556-0.5929 0.6214-1.3077 0.9311-2.1448 0.9311h-8.7172l-4.9158 3.1154v-15.147c0-0.8826 0.2958-1.635 0.8888-2.2557 0.593-0.62 1.3077-0.9311 2.1442-0.9311h10.6c0.8371 0 1.5519 0.3111 2.1448 0.9311z",
  clipRule: "evenodd",
  fill: "#001246",
  fillRule: "evenodd"
})));
export default SvgComment;